import { Deserializable } from "./Deserializable";

export class EntityDinamica implements Deserializable {

  matchKey?: string;
  rowKey?: string;
  journalingTimestamp?: number;
  changeDetails?: string; //": null
  recordAction?: string | null;

  denominacion?: string;
  documento?: string;
  iup?: string;
  periodo?: number;

  info_fh?: number;

  integrante_denominacion?: string | number;
  integrante_documento?: string | number;
  integrante_sexo?: string | number;

  constructor() {
    // This is intentional
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}

class ChangeDetails {
  fieldToChange?: string;
  newValue?: string;
}
